const employeeOptions = {
  data() {
    return {
      queryParams: {},
      showDialog: false,
      /**
       * 当前选中项
       */
      selectItem: undefined,
      /**
       * 对当前编辑项
       */
      editItem: undefined,
      enterpriseId: '',
      enterpriseFullName: '',
      discountContent: ''
    }
  },
  created() {
    const { enterpriseFullName, enterpriseId, discountContent } = this.$route.query
    this.discountContent = discountContent
    this.enterpriseId = enterpriseId
    this.enterpriseFullName = enterpriseFullName
  },
  activated() {
    const { enterpriseFullName, enterpriseId, discountContent } = this.$route.query
    if (this.enterpriseId !== enterpriseId) {
      this.enterpriseId = enterpriseId
      this.discountContent = discountContent
      this.enterpriseFullName = enterpriseFullName
    }
  },
  methods: {
    onAddEvent() {
      this.isEdit = false
      this.isChild = false
      this.selectItem = undefined
      this.showDialog = true
    },
    onEditEvent(item) {
      this.isEdit = true
      this.selectItem = { ...item }
      this.showDialog = true
    }

  }
}
export default employeeOptions